import { NavigateParams, RouteInstance, RouteParams, RouteQuery } from 'atomic-router';

export const navigate = <TRouteParams extends RouteParams = RouteParams>(
	route: RouteInstance<TRouteParams>,
	params?: Partial<NavigateParams<TRouteParams>>,
) =>
	route.navigate.prepend<void>(() => ({
		params: {} as TRouteParams,
		query: {} as RouteQuery,
		...params,
	}));
